<app-card [isHeader]=true [title]="'search_filter'|translate">
    <form (ngSubmit)="submit()" [formGroup]="form">


        <div class="row">
            <div class=" col-sm-4">

                <app-text-field
                        [control]="getFormControl('prodId')"
                        [label]="'prodId'"
                ></app-text-field>
            </div>

            <div class=" col-sm-4">


                <app-text-field
                        [control]="getFormControl('prodNm')"
                        [label]="'prodNm'"
                ></app-text-field>

            </div>


        </div>
        <div class="row">


            <div class=" col-sm-4">


                <app-select-produit-root
                    #rootpro
                    (object)="send($event)"
                    [control]="getFormControl('root')"
                    [id]="'root'"
                    [label]="'produit_niveau0'"
                >
                </app-select-produit-root>
            </div>
            <div *ngIf="getFormControl('root').value!=null" class=" col-sm-4">
                <app-select-produit-root
                    #fils1
                    (object)="sendfils($event)"
                    [control]="getFormControl('fils1')"
                    [id]="idfils1"
                    [label]="'produit_niveau1'"
                >
                </app-select-produit-root>
            </div>
            <div *ngIf="getFormControl('fils1').value!=null" class=" col-sm-4">
                <app-select-produit-root
                    #fils2
                    (object)="sendfils2($event)"
                    [control]="getFormControl('fils2')"
                    [id]="idfils2"
                    [label]="'produit_niveau2'"
                >
                </app-select-produit-root>
            </div>
            <div *ngIf="getFormControl('fils2').value!=null" class=" col-sm-4">
                <app-select-produit-root
                    #fils3
                    (object)="sendfils3($event)"
                    [control]="getFormControl('fils3')"
                    [id]="idfils3"
                    [label]="'produit_niveau3'"
                >
                </app-select-produit-root>

            </div>
            <div class=" col-sm-4">
                <app-text-field
                        [control]="getFormControl('cateId')"
                        [label]="'Code de la classification des produits'"
                ></app-text-field>
            </div>
        </div>


        <div style="text-align: end;">

            <button class="btn-blue" mat-flat-button type="submit">
                <mat-icon>{{ icons.search }}</mat-icon>
                <span translate>search</span>
            </button>

            <button (click)="reset()"
                    color="primary"
                    mat-flat-button
                    style="margin:5px;"
                    type="button"
            >
                <mat-icon>{{ icons.reset }}</mat-icon>
                <span translate>reset</span>
            </button>
        </div>


    </form>
</app-card>
<!--  <mat-card appCard>
    <mat-card-header>
      <mat-card-title translate>search_filter</mat-card-title>
    </mat-card-header>
    <mat-card-content>

    </mat-card-content>
  </mat-card>  -->
